import { render, staticRenderFns } from "./DetailText.vue?vue&type=template&id=bae1bcd0&scoped=true&"
import script from "./DetailText.vue?vue&type=script&lang=js&"
export * from "./DetailText.vue?vue&type=script&lang=js&"
import style0 from "./DetailText.vue?vue&type=style&index=0&id=bae1bcd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae1bcd0",
  null
  
)

export default component.exports